// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading_loading__gEZK4","load6":"loading_load6__zZhLE","round":"loading_round__UwRv9"};